import { AssetData } from './assetdata.class';
import { BridgeNode } from './bridgeNode.interface';
import { WorkFlow } from './workflow.class';

export class AssetService {
    assetMetaUId?: string;

    createdDate?: string;

    filableReport?: string;

    id?: string;

    lastModifiedByUserId?: string;

    lastModifiedDate?: string;

    serviceName?: string;

    subscriptionId?: string;

    displayName?: string;

    description?: string;

    restApiName?: string;

    serviceId?: string;

    organizationId?: string;

    providerOrgId?: string;

    serviceType?: string;

    assetType?: 'BRIDGE_ASSET' | 'RECON' | 'ASSET' | 'CONNECTOR' | 'PACKAGE' | 'DASHBOARD' | 'WIDGET' | '' | undefined;

    assets?: AssetService[];

    nextNodes?: string[];

    level?: number;

    tags?: { tagKey: string; tagValue: string }[];

    originalLastModifiedDate?: string;

    canCreateNewProcess?: boolean;

    canViewAllProcesses?: boolean;

    canViewIntergrations?: boolean;

    canManageWorkflow?: boolean;

    canViewVDM?: boolean;

    canProcessReports?: boolean;

    bridgePermissions?: any;

    show?: boolean;

    workflowStages?: WorkFlow[];

    assetData?: AssetData;

    request?: Request;

    filingAttributes?:
        | {
              captureOnce: boolean;
              dataType: string;
              entityName: string;
              fullId: string;
              isBusinessKey: boolean;
              isPrecaptured: boolean;
              keyId: string;
              label: string;
              value: string;
          }[]
        | boolean;

    // @property loading is used for loading symbols in home page.
    loading?: any;

    instance?: any;

    hasPermissionsFor?: { allProcesses: boolean; newProcess: boolean };

    reports?: BridgeNode[];

    componentType?: string;

    canCancelProcess?: boolean;

    status?: any;

    assetChecked?: boolean;

    noPermissions?: boolean;

    order?: number;

    isPackagedApp?: boolean;

    suspended?: boolean;

    constructor(asset?: AssetService) {
        this.assetMetaUId = asset?.assetMetaUId;
        this.subscriptionId = asset?.subscriptionId;
        this.createdDate = asset?.createdDate;
        this.filableReport = asset?.filableReport;
        this.id = asset?.id;
        this.lastModifiedByUserId = asset?.lastModifiedByUserId;
        this.lastModifiedDate = asset?.lastModifiedDate;
        this.serviceName = asset?.serviceName;
        this.displayName = asset?.displayName;
        this.restApiName = asset?.restApiName;
        this.description = asset?.description;
        this.serviceId = asset?.serviceId;
        this.assetType = asset?.assetType;
        this.organizationId = asset?.organizationId;
        this.providerOrgId = asset?.providerOrgId;
        this.serviceType = asset?.serviceType;
        this.assets = [];
        if (asset?.assets) {
            for (let i = 0; i < asset.assets.length; i++) {
                this.assets.push(new AssetService(asset.assets[i]));
            }
        }
        this.nextNodes = asset?.nextNodes;
        this.level = asset?.level;
        this.tags = asset?.tags;
        this.originalLastModifiedDate = asset?.originalLastModifiedDate;
        this.canCreateNewProcess = asset?.canCreateNewProcess;
        this.canViewAllProcesses = asset?.canViewAllProcesses;
        this.canViewIntergrations = asset?.canViewIntergrations;
        this.canManageWorkflow = asset?.canManageWorkflow;
        this.canViewVDM = asset?.canViewVDM;
        this.bridgePermissions = asset?.bridgePermissions;
        this.show = asset?.show;
        this.reports = asset?.reports || [];
        this.componentType = asset?.componentType;
        this.canCancelProcess = asset?.canCancelProcess;
        this.order = asset?.order;
        this.suspended = asset?.suspended;
    }

    pushAsset? = (asset: AssetService) => {
        this.assets.push(new AssetService(asset));
    };
}
